import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import Select from "../../../components/Select/Select";
import "./UploadBackup.css";
import { useUserStore } from "../../../contexts/userStore";
import Loader from "../../../components/Loader/Loader";
import { FiUploadCloud } from "react-icons/fi";
import BackupService from "../../../services/BackupService";
import { MdOutlineDelete } from "react-icons/md";
import { formatBytes } from "../../../utils/bytes";
import { NotificationManager } from "react-notifications";
import { S3Service } from "../../../services/S3Service";
import { TiWarning, TiWarningOutline } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { useSSEContext } from "../../../contexts/sse";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "var(--containerBackgroundColor)",
		border: "1px solid var(--borderColor)",
		borderRadius: '8px',
		boxShadow: 'var(--box-shadow)',
	},
};

function UploadBackup(props) {
	const { selectedCondominio, condominiums, selectedLicenceObj } = useUserStore();
	const { sseReceived } = useSSEContext();
	const [modalIsOpen, setModalIsOpen] = useState(props.modalIsOpen);
	const [unit, setUnit] = useState(null);
	const [showLoader, setShowLoader] = useState(false);
	const [backupFile, setBackupFile] = useState();
	const [usedSpace, setUsedSpace] = useState(0);
	const navigate = useNavigate();

	useEffect(() => {
		setModalIsOpen(props.modalIsOpen);
	}, [props.modalIsOpen]);

	async function getUsedSpace() {
		const response = await BackupService.getUsedSpace(selectedLicenceObj?.SN_equipment);
		if (response.data.usedSpace) {
			setUsedSpace(Number(response.data.usedSpace));
		}
	}

	useEffect(() => {
		setUnit(selectedCondominio);
		if (!selectedCondominio) return;
		getUsedSpace();
	}, [selectedLicenceObj])

	function handleCancel() {
		props.handleCancel(false);
	}

	async function sendBackup() {
		setShowLoader(true);
		const formData = new FormData();
		formData.append('file', backupFile);
		const response = await BackupService.uploadBackup(formData, selectedLicenceObj?.SN_equipment);
		if (response?.data) {
			await S3Service.putObject(response.data.credentials, response.data.bucketName, response.data.bucketObjectKey, backupFile);
			handleCancel();
			setBackupFile(null);
			getUsedSpace();
			navigate("../consulta-backups", { replace: true, state: {} });
		}
		setShowLoader(false);
	}

	const changeHandler = (event) => {
		const file = event.target.files[0];
		const acceptedBackupMimeTypes = [
			"application/zip",
			"application/octet-stream",
			"application/x-zip-compressed",
			"multipart/x-zip"
		];
		if (!acceptedBackupMimeTypes.includes(file.type)) {
			NotificationManager.warning("", "Formato não aceito!", 5000);
			return;
		}
		setBackupFile(file);
	};

	function calculateUsedSpace() {
		return usedSpace + (backupFile ? backupFile.size : 0);
	}

	function getTotalSpace() {
		return Number(selectedLicenceObj.backupSize);
	}

	useEffect(() => {
		async function onSseReceived() {
			if (!sseReceived.content) return;
			if (selectedCondominio !== Number(sseReceived.content.unitId))
				return;
			if (['backupImported'].includes(sseReceived?.action)) {
				getUsedSpace();
			}
		}
		onSseReceived();
	}, [sseReceived]);

	return (
		<>
			{modalIsOpen && (
				<Modal
					isOpen={modalIsOpen}
					onRequestClose={handleCancel}
					style={customStyles}
					contentLabel="Modal"
					ariaHideApp={false}
				>
					<div className="modal-content-container modal-upload-backup">
						<h1 className="modal-text">
							<FiUploadCloud />
							Enviar um novo backup
						</h1>
						<React.Fragment>
							<p className="delete-button-modal-text"></p>
							<div className="form-wrapper">
								<Select
									labelText="Unidade"
									name="unit"
									id="unit"
									value={unit}
									onChange={({ target }) =>
										setUnit(target.value)
									}
									required={true}
									options={props.optionsCondominios}
								/>
								{unit && selectedLicenceObj && (
									<div>
										<div className="disk-space-labels">
											<label style={{ fontSize: '0.9rem', display: 'block' }}>Espaço</label>
											<span>
												{formatBytes(calculateUsedSpace())} / {formatBytes(getTotalSpace())}
											</span>
										</div>
										<div className="size-bar">
											<div className="used-bar" style={{
												'width': `${(calculateUsedSpace() / getTotalSpace()) * 100}%`,
												'backgroundColor': `${calculateUsedSpace() > getTotalSpace() ? 'red' : '#4bdc55'}`
											}}></div>
										</div>
										{selectedLicenceObj.enabledRotation && calculateUsedSpace() > getTotalSpace() && (
											<p style={{ display: 'flex', gap: '5px', marginTop: '10px', fontSize: '0.8rem', opacity: 0.7, lineHeight: 1.2, color: 'var(--textColor)' }}>
												<TiWarning size={16} />
												Espaço insuficiente, será utilizado o recurso de rotação de backup<br /> o mais antigo será deletado.
											</p>
										)}
									</div>
								)}
								<div>
									<label htmlFor="upload-backup-input" style={{ fontSize: '0.9rem', marginBottom: '7px', display: 'block' }}>Arquivo</label>
									{backupFile ? (
										<div className="backup-file-preview">
											<div>
												<span>
													<span>{backupFile.name}</span>
													<span>{formatBytes(backupFile.size)}</span>
												</span>
											</div>
											<button type="button" onClick={e => setBackupFile(null)}>
												<MdOutlineDelete size={18} />
											</button>
										</div>
									) : (
										<div className="upload-button-wrapper">
											<input
												id="upload-backup-input"
												className="upload-button-input"
												type="file"
												name="file"
												onChange={changeHandler}
											/>
										</div>
									)}
								</div>
							</div>
						</React.Fragment>
						<div className="modal-buttons-container">
							{showLoader ? (
								<Loader style={{ marginTop: '0px' }} />
							) : (
								<Button onClick={() => { sendBackup() }} label="Enviar"></Button>
							)}
						</div>
					</div>
				</Modal>
			)}
		</>
	);
}

export default UploadBackup;